import type { DataGridLeafColumn } from '@ibsys/kit';
import { cn } from '@/shared/lib';

/**
 * Готовит колонку `DataGrid`, переносящую текст по строкам. Её значение стоит по середине высоты
 * строки, как у остальных колонок списка: строка, выросшая из-за переноса, не читается ступеньками.
 */
export const withWrappedText = <TData>(column: DataGridLeafColumn<TData>): DataGridLeafColumn<TData> => ({
  ...column,
  wrap: true,
  // Колонку с переносом грид прижимает к верху строки своим классом — перебивается только важностью
  className: cn('items-center!', column.className),
});
